import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit';

import type { NavigationHistoryAppState, NavigationHistoryItem } from './types';

const initialState: NavigationHistoryAppState = { history: [] };

const updateHistoryItemByIndex = (
  history: Draft<NavigationHistoryItem>[],
  index: number,
  historyItem: Partial<NavigationHistoryItem>,
) => {
  const effectiveIndex = index < 0 ? history.length + index : index;
  const item = history[effectiveIndex];
  if (item) {
    Object.assign(item, historyItem);
  }
};

export const navigationHistorySlice = createSlice({
  name: 'navigation_history',
  initialState,
  reducers: {
    pushNavigationHistoryItem: (
      state,
      action: PayloadAction<NavigationHistoryItem>,
    ) => {
      state.history.push(action.payload);
    },
    popNavigationHistoryItem: (state) => {
      state.history.pop();
    },
    updateLastNavigationHistoryItem: (
      state,
      action: PayloadAction<Partial<NavigationHistoryItem>>,
    ) => {
      updateHistoryItemByIndex(state.history, -1, action.payload);
    },
    updateNthNavigationHistoryItem: (
      state,
      action: PayloadAction<{
        index: number;
        historyItem: Partial<NavigationHistoryItem>;
      }>,
    ) => {
      updateHistoryItemByIndex(
        state.history,
        action.payload.index,
        action.payload.historyItem,
      );
    },
    resetNavigationHistoryToLastItem: (state) => {
      if (state.history.length > 1) {
        state.history = state.history.slice(-1);
      }
    },
    clearNavigationHistory: (state) => {
      state.history = [];
    },
  },
});

export const {
  pushNavigationHistoryItem,
  popNavigationHistoryItem,
  updateLastNavigationHistoryItem,
  updateNthNavigationHistoryItem,
  resetNavigationHistoryToLastItem,
  clearNavigationHistory,
} = navigationHistorySlice.actions;

export const navigationHistoryReducer = navigationHistorySlice.reducer;
